import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';
import { isCardSerialValidOrEmpty, isCardSerialValid } from '../../../../../../common/validation';
import { actions, selectors } from '../../../../../../modules/customer/profile/hardwareProducts';
import TextInput from '../../../../../components/TextInput';
import HardwareResults from './HardwareResults';
import { selectors as ui } from '../../../../../../modules/ui';

const CardInput = ({addCardForm, setCardSerial, getCardBySerial, isBundledHardware}) => {

    const {serialNumber, isValid, isLoading, notEligibleToMove, list} = addCardForm;

    const onSerialInputChange = ({ target: { value: serial } }) => {
        setCardSerial(serial);
        if (isCardSerialValid(serial)) {
            getCardBySerial(serial);
        }
    }

   const onSerialInputKeyPress = (e) => {
        if (!(ui.isNumericKeyPress(e) || ui.isCtrlCKeyPress(e) || ui.isCtrlVKeyPress(e))) {
          e.preventDefault();
        }
    }
    return (
        <div className="wrapper program-card">
            <div className="image program-card"></div>
            <div className="info-text">
                Kortnummeret finner du under strekkoden. Skriv bare tall - ikke mellomrom eller - foran siste siffer
            </div>
            <TextInput
                value={serialNumber}
                onChange={onSerialInputChange}
                onKeyPress={onSerialInputKeyPress}
                isValid={isValid}
                placeholder="Kortnummer - 12 siffer"
                containerClass="number-input"
                errorMessage="Ugyldig programkortnummer"
            />
            {isCardSerialValid(serialNumber) &&
                <HardwareResults productData={addCardForm}
                    titleText='Programkort Funnet'
                    notFoundText='Programkortnummer ikke funnet' />
            } 
            { isBundledHardware && isValid && serialNumber !== "" && !isLoading &&
                <div className="alert alert-info text-warning bundled-message">
                    Det er registrert følgende programkort i denne mottakeren.
                </div>
            }
        </div>
    );
}

const mapStateToProps = createStructuredSelector({
    addCardForm: selectors.addCardForm,
    isBundledHardware: selectors.isBundledHardware
});

const mapDispatchToProps = (dispatch, props) => ({
    setCardSerial: (serial) => dispatch(actions.setCardSerialNumber(serial, isCardSerialValidOrEmpty(serial))),
    getCardBySerial: (serial) => dispatch(actions.getCardBySerial(serial))    
});

export default connect(mapStateToProps, mapDispatchToProps)(CardInput)